var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center transition-all-0.3 items-center pt-5 gap-2"},[_c('Loader'),_c('div',[_c('TransitionGroup',{staticClass:"hollow-list transition-all-0.3",attrs:{"name":"list","as":"ul"}},_vm._l((_vm.info),function(i,idx){return _c('li',{key:idx},[_vm._v(_vm._s(i))])}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }